<script>
  import {faMoneyBillAlt} from '@fortawesome/free-solid-svg-icons'
  import { mapGetters } from 'vuex'
  import ListView from '../base/ListView.vue'
  import FilterLookupSelect from '../base/FilterLookupSelect.vue'

  export default {
    components: {
      ListView,
      FilterLookupSelect
    },
    data () {
      return {
        iconToggleInvoiced: faMoneyBillAlt
      }
    },
    computed: {
      invoiced () {
        return this.$store.getters['workinghour/list/filter']['invoice[null]'] === 'ignore'
      },
      ...mapGetters({
        customer: 'workinghour/list/references/customer/item',
        invoice: 'workinghour/list/references/invoice/item',
      })
    },
    methods: {
      toggleInvoiced () {
        this.$store.dispatch('workinghour/list/setFilter', {'invoice[null]': this.invoiced ?  'true' : 'ignore'})
      },
    }
  }
</script>
<template>
  <list-view store="workinghour" add-route="WorkingHourCreate" edit-route="WorkingHourUpdate">
    <template v-slot:filter="">
      <b-form-group class="mb-2 mr-sm-2 mb-sm-0">
        <b-input-group>
          <b-button
            :pressed="invoiced"
            :variant="(invoiced ? 'danger' : 'primary')"
            @click="toggleInvoiced"
            :title="$t(invoiced ? 'workinghour.filter-header.invoiced-hide' : 'workinghour.filter-header.invoiced-show')"
          >
            <font-awesome-icon :icon="iconToggleInvoiced" size="lg" />
            <span class="sr-only">&nbsp;{{$t(invoiced ? 'workinghour.filter-header.invoiced-hide' : 'workinghour.filter-header.invoiced-show')}}</span>
          </b-button>
        </b-input-group>
      </b-form-group>
      <b-form-group class="mb-2 mr-sm-2 mb-sm-0">
        <b-input-group>
          <filter-lookup-select
            store="workinghour/list/lookup/customer"
            :placeholder="$t('workinghour.filter-header.customer-placeholder')"
            :search-placeholder="$t('workinghour.filter-header.customer-search-placeholder')"
          >
            <template v-slot:selected-item="slotProps">
              {{slotProps.item.addr1}}
              {{slotProps.item.addr2}}
            </template>
            <template v-slot:item="slotProps">
              {{slotProps.item.addr1}}<br/>
              {{slotProps.item.addr2}}
            </template>
          </filter-lookup-select>
        </b-input-group>
      </b-form-group>
      <b-form-group class="mb-2 mr-sm-2 mb-sm-0">
        <b-input-group>
          <filter-lookup-select
            store="workinghour/list/lookup/project"
            :placeholder="$t('workinghour.filter-header.project-placeholder')"
            :search-placeholder="$t('workinghour.filter-header.project-search-placeholder')"
          >
            <template v-slot:selected-item="slotProps">
              {{slotProps.item.projectnr}} - {{slotProps.item.name}}
            </template>
            <template v-slot:item="slotProps">
              {{slotProps.item.projectnr}} - {{slotProps.item.name}}
            </template>
          </filter-lookup-select>
        </b-input-group>
      </b-form-group>
    </template>

    <template v-slot:header="">
      <b-col md="1"><strong>{{ $t('workinghour.start.label') }}</strong></b-col>
      <b-col md="5"><strong>{{ $t('workinghour.description.label') }}</strong></b-col>
      <b-col md="1" class="text-right"><strong>{{ $t('workinghour.amount.label') }}</strong></b-col>
      <b-col md="1" class="text-right"><strong>{{ $t('workinghour.singleprice.label') }}</strong></b-col>
      <b-col md="1" class="text-right"><strong>{{ $t('workinghour.totalprice.label') }}</strong></b-col>
      <b-col md="1" class="text-right"><strong>{{ $t('workinghour.taxrate.label') }}</strong></b-col>
    </template>

    <template v-slot:item="slotProps">
      <b-col md="1">{{slotProps.item.start|formatDate}} {{slotProps.item.timeBegin}}</b-col>
      <b-col md="5" :inner-html.prop="(customer(slotProps.item.customer).addr1 + ':\n' + slotProps.item.description)|formatText"></b-col>
      <b-col md="1" class="text-right">{{slotProps.item.amount}}</b-col>
      <b-col md="1" class="text-right">{{slotProps.item.singleprice|formatMoney}}</b-col>
      <b-col md="1" class="text-right">{{slotProps.item.totalprice|formatMoney}}</b-col>
      <b-col md="1" class="text-right">{{slotProps.item.taxrate}}%</b-col>
    </template>
    <template v-slot:buttons="slotProps">
      <b-button
        :to="{name: 'InvoiceShow', params: { id: slotProps.item['invoice'] }}"
        :disabled="!slotProps.item['invoice']"
      >
        <span>Invoice</span>
      </b-button>
    </template>
  </list-view>
</template>
